(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("createConicalGradient", [], factory);
	else if(typeof exports === 'object')
		exports["createConicalGradient"] = factory();
	else
		root["createConicalGradient"] = factory();
})(this, function() {
return 